"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("../../util/helpers");

var _classNames = _interopRequireDefault(require("../../util/classNames"));

require("./Slider.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Slider = function Slider(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      vertical = _ref.vertical,
      min = _ref.min,
      max = _ref.max,
      disabled = _ref.disabled;

  var range = function range() {
    return Array.isArray(value);
  };

  var getMin = function getMin() {
    return min || 0;
  };

  var getMax = function getMax() {
    return max || 100;
  };

  var getRange = function getRange() {
    return getMax() - getMin();
  };

  var _useState = (0, _react.useState)(range() ? Math.floor((value[0] + value[1]) / 2) : null),
      _useState2 = _slicedToArray(_useState, 2),
      pivot = _useState2[0],
      setPivot = _useState2[1];

  (0, _react.useEffect)(function () {
    if (Array.isArray(value)) {
      setPivot(Math.floor((value[0] + value[1]) / 2));
    }
  }, [value, min, max]);

  var onChangeHandler = function onChangeHandler(e) {
    return onChange(parseInt(e.currentTarget.value, 10));
  };

  var fillStyle = function fillStyle() {
    if (range()) {
      return {
        left: (value[0] - getMin()) / getRange() * 100 + '%',
        right: (getMax() - value[1]) / getRange() * 100 + '%'
      };
    } else {
      if (vertical) return {
        height: value + '%'
      };else return {
        width: value + '%'
      };
    }
  };

  var magic = function magic(_ref2) {
    var target = _ref2.currentTarget;
    var newValue = parseInt(target.value, 10);

    if (target.name === 'a-slider') {
      // setPivot(Math.min(Math.ceil((newValue + value[1]) / 2), value[1] - 1));
      setPivot(Math.floor((value[0] + value[1]) / 2));
      onChange((0, _helpers.updateArrayImmutably)(value, 0, newValue));
    }

    if (target.name === 'b-slider') {
      // setPivot(Math.max(Math.floor((newValue + value[0]) / 2), value[0] + 1));
      setPivot(Math.floor((value[0] + value[1]) / 2));
      onChange((0, _helpers.updateArrayImmutably)(value, 1, newValue));
    }
  };

  var classes = (0, _classNames["default"])({
    vertical: vertical,
    range: range(),
    disabled: disabled
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-slider ".concat(classes)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "bar"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "fill",
    style: fillStyle()
  })), range() ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
    disabled: disabled,
    name: "a-slider",
    type: "range",
    min: getMin(),
    max: pivot,
    value: value[0],
    style: {
      width: (pivot - getMin()) / getRange() * 100 + '%'
    },
    onChange: magic
  }), /*#__PURE__*/_react["default"].createElement("input", {
    disabled: disabled,
    name: "b-slider",
    type: "range",
    min: pivot,
    max: getMax(),
    value: value[1],
    style: {
      width: (getMax() - pivot) / getRange() * 100 + '%'
    },
    onChange: magic
  })) : /*#__PURE__*/_react["default"].createElement("input", {
    disabled: disabled,
    type: "range",
    min: getMin(),
    max: getMax(),
    value: value,
    onChange: onChangeHandler
  }));
};

Slider.propTypes = {
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)]).isRequired,
  onChange: _propTypes["default"].func.isRequired,
  vertical: _propTypes["default"].bool,
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  disabled: _propTypes["default"].bool
};
var _default = Slider;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/Slider/Slider.js
// module id = 700
// module chunks = 0